export default __webpack_public_path__ + "static/media/mockup.28541fbc.png";